import { captureEvent } from "@Light/app/analytics";
import { maybeRequirementValue } from "@Light/components/enroll/flow/screen.ts";
import { RateContext } from "@Light/utils/plan";
import { useEffect, useState } from "react";
import { useEnrollment } from "../flow/context";
import { useTermMonthOptions, useTermRates } from "../rate";
import { EnrollRateOffer } from "./EnrollRateOffer";
import { RateUnavailableSheet } from "./RateUnavailableSheet";

export function ConfirmRate() {
  const { nextMutation, requirements } = useEnrollment();
  const { defaultTerm, offeredTerms } = useTermMonthOptions();

  const { rates, query } = useTermRates({ refetchOnMountOrArgChange: true });

  // A failed acceptance (e.g. an expired rate) leaves the cached rate stale, so
  // refetch to surface a fresh rate before the user can re-accept.
  const { refetch } = query;
  useEffect(() => {
    if (nextMutation.isError) void refetch();
  }, [nextMutation.isError, refetch]);

  const availableRates = rates.filter((r) => r.rate);
  const availableTerms = availableRates.map((r) => r.term);

  const maybeAcceptance = maybeRequirementValue(requirements.acceptance);

  const patchedTerm: number | undefined = maybeAcceptance
    ? availableRates.find((r) => r.rate?.uuid === maybeAcceptance.rate_id)?.term
    : undefined;

  const [selectedTerm, setSelectedTerm] = useState<number | undefined>(
    undefined,
  );

  const preferredTerm = selectedTerm ?? patchedTerm ?? defaultTerm;

  const effectiveTerm = availableTerms.includes(preferredTerm)
    ? preferredTerm
    : availableTerms[0];

  const rate = availableRates.find((r) => r.term === effectiveTerm)?.rate;

  const allFailed =
    query.currentData !== undefined && availableRates.length === 0;
  const toggleTerms = availableTerms.length > 0 ? availableTerms : offeredTerms;

  return (
    <>
      <RateContext.Provider value={rate}>
        <EnrollRateOffer
          terms={toggleTerms}
          selectedTerm={effectiveTerm ?? toggleTerms[0] ?? 0}
          onSelectTerm={(term) => {
            captureEvent("rate_term_selected", { term_months: term });
            setSelectedTerm(term);
          }}
        />
      </RateContext.Provider>
      <RateUnavailableSheet
        open={allFailed}
        onReload={() => {
          void query.refetch();
        }}
      />
    </>
  );
}
